import createImageIcon from './createImageIcon';
import path from './hamburger.svg';

export default createImageIcon({displayName: 'HamburgerIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/HamburgerIcon.js